import PropTypes from "prop-types"
import React, { useEffect, Suspense, lazy } from "react"
import wrapper from "./wrapper"
import ScrollToTop from "./helpers/scroll-top"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { ToastProvider } from "react-toast-notifications"
import { multilanguage, loadLanguages } from "redux-multilanguage"
import { connect } from "react-redux"
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic"
import { saveUserData } from "./redux/actions/userActions"

// API
import { User } from "./api"

import { unregister } from "./serviceWorker"

unregister()

// home pages
const Home = lazy(() => import("./pages/home/Home"))

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"))

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"))

// other pages
const About = lazy(() => import("./pages/other/About"))
const Contact = lazy(() => import("./pages/other/Contact"))
const MyAccount = lazy(() => import("./pages/other/MyAccount"))
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"))
const Otp = lazy(() => import("./pages/other/Otp"))
const OtpVerify = lazy(() => import("./pages/other/OtpVerify"))
const Order = lazy(() => import("./pages/other/Order"))

const Cart = lazy(() => import("./pages/other/Cart"))
const Wishlist = lazy(() => import("./pages/other/Wishlist"))
const Compare = lazy(() => import("./pages/other/Compare"))
const Checkout = lazy(() => import("./pages/other/Checkout"))
const CheckoutTest = lazy(() => import("./pages/other/CheckoutTest"))
const GuestCheckout = lazy(() => import("./pages/other/GuestCheckout"))
const Account = lazy(() => import("./pages/other/Account"))

const NotFound = lazy(() => import("./pages/other/NotFound"))
const Logout = lazy(() => import("./pages/other/Logout"))

const App = (props) => {
  if (localStorage.getItem("userData") != null)
    User.GetUserAPI(localStorage.getItem("userData")).then((res) => {
      let data = {
        userId: res.data[0].userID,
        firstName: res.data[0].firstName,
        lastName: res.data[0].LastName,
        email: res.data[0].email,
        phone: res.data[0].phone,
        profile: res.data[0].profile,
      }

      props.saveUserData(data)
    })

  useEffect(() => {
    props.dispatch(
      loadLanguages({
        languages: {
          en: require("./translations/english.json"),
          fn: require("./translations/french.json"),
          de: require("./translations/germany.json"),
        },
      })
    )
  })

  return (
    <ToastProvider placement="bottom-left">
      <BreadcrumbsProvider>
        <Router>
          <ScrollToTop>
            <Suspense
              fallback={
                <div className="flone-preloader-wrapper">
                  <div className="flone-preloader">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              }
            >
              <Switch>
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Home}
                />

                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/shop"}
                  component={ShopGridStandard}
                />

                {/* Shop product pages */}
                <Route
                  path={process.env.PUBLIC_URL + "/product/:id"}
                  render={(routeProps) => (
                    <Product {...routeProps} key={routeProps.match.params.id} />
                  )}
                />

                {/* Other pages */}
                <Route
                  path={process.env.PUBLIC_URL + "/about"}
                  component={About}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/contact"}
                  component={Contact}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/my-account"}
                  component={Account}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/signup"}
                  component={LoginRegister}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/order"}
                  component={Order}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/cart"}
                  component={Cart}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/wishlist"}
                  component={Wishlist}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/compare"}
                  component={Compare}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/checkout"}
                  component={CheckoutTest}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/guest-checkout"}
                  component={GuestCheckout}
                />
                <Route path={process.env.PUBLIC_URL + "/otp"} component={Otp} />
                <Route
                  path={process.env.PUBLIC_URL + "/verify-otp"}
                  component={OtpVerify}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/logout"}
                  component={Logout}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/not-found"}
                  component={NotFound}
                />

                <Route exact component={NotFound} />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </Router>
      </BreadcrumbsProvider>
    </ToastProvider>
  )
}

App.propTypes = {
  dispatch: PropTypes.func,
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  saveUserData: (data) => {
    dispatch(saveUserData(data))
  },
})

export default wrapper(
  connect(mapStateToProps, mapDispatchToProps)(multilanguage(App))
)
